import { render, staticRenderFns } from "./SetAstrolabe.vue?vue&type=template&id=dcf0e6b6&scoped=true&"
import script from "./SetAstrolabe.vue?vue&type=script&lang=js&"
export * from "./SetAstrolabe.vue?vue&type=script&lang=js&"
import style0 from "./SetAstrolabe.vue?vue&type=style&index=0&id=dcf0e6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf0e6b6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYReverseTransition})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcf0e6b6')) {
      api.createRecord('dcf0e6b6', component.options)
    } else {
      api.reload('dcf0e6b6', component.options)
    }
    module.hot.accept("./SetAstrolabe.vue?vue&type=template&id=dcf0e6b6&scoped=true&", function () {
      api.rerender('dcf0e6b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SetAstrolabe.vue"
export default component.exports